import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SourcingScenarioCreatePage } from '@/areas/sourcing-scenarios/SourcingScenarioForm/SourcingScenarioCreatePage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/scenarios/create')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ demandGroupId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const demandGroupId = Route.useSearch({ select: (search) => search.demandGroupId });
    return <SourcingScenarioCreatePage {...pathParams} demandGroupId={demandGroupId} />;
}
